import axios, { AxiosResponse } from "axios";

export const uploadImage = (
  url: string,
  file: File,
  onSuccess: (success: AxiosResponse<any>) => void,
  onError: (err: Error) => void
) => {
  axios
    .put(url, file, { headers: { "Content-Type": file.type } })
    .then((result) => {
      onSuccess(result);
    })
    .catch((err) => {
      onError(err);
    });
};
